// Packages
import React from 'react';
import { KiteDialog } from '@kite/react-kite';

// Hooks
import { useAnalytics } from 'hooks/useAnalytics';
import { useAuthSession } from 'hooks/useAuthSession';

// Misc
import { currentPageTitle } from 'contexts/utils/analyticsUtils';
import { commonAnalytics } from 'utils/commonAnalytics';

/** Show Auto Logout modal if user has been idle for an extended period of time. */
const AutoLogout = () => {
  // Hooks
  const { trackButtonEvent } = useAnalytics();
  const { stillHereBtn, signOutBtn } =
    commonAnalytics.autoLogoutModal.buttonClicks;

  const { showIdlePrompt, resetIdlePrompt, signOut } = useAuthSession();

  const handleStillHere = (): void => {
    trackButtonEvent(stillHereBtn, { siteSection: currentPageTitle() });
    resetIdlePrompt();
  };

  const handleSignOut = (): void => {
    trackButtonEvent(signOutBtn, { siteSection: currentPageTitle() });
    signOut().catch(console.error);
  };

  return (
    <KiteDialog
      title="Still There?"
      open={showIdlePrompt}
      onClose={handleStillHere}
      primaryBtnLabel="Sign Out"
      onPrimaryBtnClick={handleSignOut}
      secondaryBtnLabel="Still Here"
      onSecondaryBtnClick={handleStillHere}
    >
      <p>To keep your account safe, we&apos;ll sign you out in five minutes.</p>
    </KiteDialog>
  );
};

export default AutoLogout;
